module.exports = __webpack_public_path__ + "media/images/tiedye/sunset-1526d76499d830011307a8ee40b3eeef.jpg";